export default {
      id: "icon-sticker-langue-usage",
      viewBox: "0 0 129.2 129.2",
      url: __webpack_public_path__ + "icons.svg#icon-sticker-langue",
      toString: function () {
        return this.url;
      }
    }